import {
  hasActiveBlogPlan,
  isBlogGenerationAllowed,
  isBlogPublishingAllowed,
  type BlogCreditsState,
} from "../../../Utils/SupabaseServices/blogCredits";

/**
 * @deprecated Prefer `isBlogPublishingBlocked` with credits/admin context.
 * Kept as a hard-off fallback only when callers have no user/credits yet.
 */
export const BLOG_PUBLISHING_DISABLED = false;

export const BLOG_PUBLISHING_NOTICE =
  "Subscribe to a Blog plan to publish. Publishing uses one publishing credit per post.";

export const BLOG_PLAN_REQUIRED_NOTICE =
  "Choose a Blog plan to unlock generating and publishing. Generation and publishing use monthly credits.";

export const BLOG_GENERATION_LOCKED_NOTICE =
  "Subscribe to a Blog plan to generate posts.";

export const BLOG_EDITOR_LOCKED_NOTICE =
  "Subscribe to a Blog plan to use the editor. Pick a plan in Settings.";

export const BLOG_NAV_UNLOCK_TIP =
  "Add Blog to your site navigation after you subscribe to a Blog plan.";

/** True when publish should be blocked for this viewer. */
export function isBlogPublishingBlocked(opts: {
  isAdmin?: boolean;
  credits?: BlogCreditsState | null;
  userData?: any;
}): boolean {
  if (opts.isAdmin) return false;
  if (!opts.credits) return true;
  return !isBlogPublishingAllowed({
    isAdmin: false,
    credits: opts.credits,
    userData: opts.userData,
  });
}

/** True when generate / editor create flows should be blocked for this viewer. */
export function isBlogGenerationBlocked(opts: {
  isAdmin?: boolean;
  credits?: BlogCreditsState | null;
  userData?: any;
}): boolean {
  if (opts.isAdmin) return false;
  if (!opts.credits) return true;
  return !isBlogGenerationAllowed({
    isAdmin: false,
    credits: opts.credits,
    userData: opts.userData,
  });
}

/** Public site nav: unlock Blog/Journal once a Blog plan is active (or admin). */
export function isBlogNavUnlocked(opts: {
  isAdmin?: boolean;
  credits?: BlogCreditsState | null;
  userData?: any;
}): boolean {
  if (opts.isAdmin) return true;
  if (!opts.credits) return false;
  return hasActiveBlogPlan(opts.credits, opts.userData);
}
